<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light v-if="dialog">
            <v-alert v-if="false" color="error" icon="warning"  value="true">
            </v-alert>
        <v-card-title class="headline grey--text">
            Días de juego
        </v-card-title>
        <v-card-text class="pt-0">


          <v-tabs  v-model="activeField">
            <v-tabs-bar dark>
              <v-tabs-item

                v-for="(field,index) in fields"
                :key="'field' + index"
                :href="'#field' + index"
                ripple
              >
                {{ field.obj.name }}
              </v-tabs-item>
              <v-tabs-slider color="black"></v-tabs-slider>
            </v-tabs-bar>
            <v-tabs-items>
              <v-tabs-content
                v-for="(field,index) in fields"
                :key="'field'+index"
                :id="'field' + index"
              >
                <weekly-hours-selector :model="field.intervals"/>
              </v-tabs-content>
            </v-tabs-items>
          </v-tabs>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="cancel()">Cancelar</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import WeeklyHoursSelector from './WeeklyHoursSelector'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Match from '@/models/match'
import Utils from '@/utils/utils'

export default {
    name: 'SlotGeneratorModal',
    props: {
        dialog: { required: true, default: true },
        sets: { required: false, default: [] },
        periodicity: { required: false, default: 5 },
    },
    components: {
      WeeklyHoursSelector
    },
    data() {
        return {
          activeField:null,
          fields:[]

        }
    },
    created() {
      //do something after creating vue instance

    },
    watch: {
      currentFields(val){
        this.buildFieldsModel()
      },
      dialog(val){
        if(val){
          this.buildFieldsModel()
        }
      }

    },
    computed: {
      ...mapGetters([
          'currentFields'
      ])
    },
    methods: {
      ...mapActions([
        'fieldsAreAvailable'
      ]),
      cancel(){
        this.$emit('response', null)
      },
      confirm(){
        /*Obtengo los dias de los sets para
        insertar en dichos dias los slots de juegos
        en base a los intervalos seleccionados para
        cada cancha
        */

        var matchesResult = []
        let totalSets = this.sets.length
        for(var i = 0; i < totalSets;i++){
          let set = this.sets[i]
          if(set.type != "regular"){
            continue
          }
          let initialDate = moment(set.start_date)
          //console.log("////",initialDate.toDate())
          let finalDate
          if(i == totalSets-1 || this.sets[i+1].type != "regular"){
            finalDate = moment(set.start_date).add(this.periodicity,"d")
          }else{
            finalDate = moment(this.sets[i+1].start_date)
          }
          let diff = finalDate.diff(initialDate,'days')

          /*Aqui recorro todos las fechas de un set*/
          for(var x = 0 ; x < diff;x++){
            /*Obtengo la fecha*/
            let date = initialDate.clone().add(x,"days")
            /*Obtengo el dia de la semana*/
            let dayOfWeek = parseInt(date.format("d"))
            /*Recorro las canchas */

            for(var f in this.fields){
              /*Obtengo el arreglo de intervalos
              del dia de la semana especifico
              de la cancha*/

              let dayIntervals = this.fields[f].intervals[dayOfWeek]
              /*Recorro el arreglo de intervalos*/
              for(var n in dayIntervals){
                let interval = dayIntervals[n]
                var match = new Match()
                match.date = date.clone()
                match.date.seconds(0)
                match.date.minutes(interval.initialTime.minutes)
                match.date.hours(interval.initialTime.hours)
                match.date = match.date.toDate()
                match.duration = interval.duration
                match.court = this.fields[f].obj
                match.setIndex = i

                if(this.checkDateAvailabilityInlocalData(match)){
                  //set.matches.push(match)
                  matchesResult.push(match)
                }
              }
            }
          }


        }
        this.checkDateAvailabilityInServer(matchesResult)
        this.$emit('response', matchesResult)
      },
      buildFieldsModel(){
        this.fields.length = 0
        for(var i = 0; i < this.currentFields.length ; i++){
          let field = this.currentFields[i]
          this.fields.push({
            obj:field,
            intervals:[]
          })
        }
      },
      checkDateAvailabilityInlocalData(match){
        for(var s in this.sets){
          let set = this.sets[s]
          for(var m in set.matches){
            let matchToCompare = set.matches[m]
            if(match.court!=matchToCompare.court) continue;
            let matchDate = moment(match.date)
            let matchToCompareDate = moment(matchToCompare.date)
            if(Utils.overlapsByDurarion(matchDate,matchToCompareDate,match.duration,matchToCompare.duration)){
              return false
            }
          }
        }
        return true
      },
      checkDateAvailabilityInServer(matches){
        this.fieldsAreAvailable(matches)
      }
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/SlotGeneratorModal.vue